var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps-tabs"},[_c('div',{class:_vm.drawStepsClasses,on:{"click":_vm.drawSteps}},[_vm._v(" Tracer les tronçons ")]),_c('div',{class:_vm.allItineraryClasses,on:{"click":_vm.allItinerary}},[_vm._v(" Tout l'itinéraire ")])])}
var staticRenderFns = []

export { render, staticRenderFns }